import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ForcePublishReceiverResponseModel } from '../models/force-publish-receiver-response-model';
import { ForcePublishReceiversService } from '../force-publish-receivers.service';

@Component({
    selector: 'edit-force-publish-receiver',
    standalone: true,
    imports: [CommonModule, FormsModule],
    providers: [ForcePublishReceiversService],
    templateUrl: './edit-force-publish-receiver.component.html'
})
export class EditForcePublishReceiverComponent implements OnInit {
    @Input() receiver: ForcePublishReceiverResponseModel;
    @Input() isNew: boolean = false;

    public model: ForcePublishReceiverResponseModel;
    public isSaving: boolean = false;
    public errorMessage: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private receiversService: ForcePublishReceiversService
    ) {}

    ngOnInit(): void {
        if (this.isNew) {
            this.model = {
                id: 0,
                receiver: ''
            };
        } else {
            this.model = { ...this.receiver };
        }
    }

    public save() {
        this.isSaving = true;
        this.errorMessage = '';

        if (this.isNew) {
            this.receiversService.create(this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to create the receiver. Please try again.';
                }
            });
        } else {
            this.receiversService.update(this.receiver.id, this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to update the receiver. Please try again.';
                }
            });
        }
    }

    public cancel() {
        this.activeModal.dismiss('cancel');
    }
}
